<!--
 * @Description  : 已关联文库
 * @Author       : zcc
 * @Date         : 2025-04-25 16:58:30
 * @LastEditors  : zcc
 * @LastEditTime : 2025-05-06 10:27:47
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\library\library-type-management\components\relate-dialog.vue
-->
<template>
  <el-dialog
    :title="dialogObj.title"
    v-if="dialogObj.visible"
    :visible.sync="dialogObj.visible"
    :width="dialogObj.width"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <template v-if="dialogObj.visible">
      <el-form
        ref="searchForm"
        class="table-form"
        :model="searchForm"
        label-width="100px"
      >
        <el-row noSpace>
          <el-col :span="6">
            <el-form-item label="标题" prop="title">
              <el-input
                v-model="searchForm.title"
                placeholder="请输入"
                class="w100"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="文号" prop="referNo">
              <el-input
                v-model="searchForm.referNo"
                placeholder="请输入"
                class="w100"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="颁布机关" prop="issueUnit">
              <el-input
                v-model="searchForm.issueUnit"
                placeholder="请输入"
                class="w100"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="2">
            <el-button
              type="text"
              class="ml10"
              @click="showMoreSearch = !showMoreSearch"
            >
              {{ showMoreSearch ? "收起" : "更多" }}
              <svg-icon
                :icon-class="showMoreSearch ? 'pack-up' : 'pack-down'"
                class="ml5"
              ></svg-icon>
            </el-button>
          </el-col>
          <el-col :span="4" class="text-right">
            <el-button type="primary" plain @click="resetSearch">
              重置
            </el-button>
            <el-button type="primary" class="ml10" @click="fetchData">
              查询
            </el-button>
          </el-col>
        </el-row>

        <el-row noSpace v-if="showMoreSearch">
          <el-col :span="6">
            <el-form-item label="时效性" prop="efficient">
              <el-select
                v-model="searchForm.efficient"
                clearable
                multiple
                collapse-tags
                filterable
              >
                <el-option
                  :label="item.sname"
                  :value="item.value"
                  v-for="item in projectDict.zsksxx"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="施行日期" prop="dateArr">
              <el-date-picker
                v-model="searchForm.dateArr"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="所属分类" prop="type">
              <el-cascader
                class="w100 sp-cascader"
                clearable
                v-model="searchForm.type"
                disabled
                placeholder="请选择"
                :options="typeDict"
                :props="{
                  expandTrigger: 'hover',
                  label: 'sname',
                  multiple: true,
                  value: 'id',
                  emitPath: false,
                  checkStrictly: true
                }"
                collapse-tags
                separator=">"
              ></el-cascader>
              <!-- <el-input
                v-model="searchForm.type"
                disabled
                placeholder="请输入"
                class="w100"
                clearable
              ></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 下方表格内容 -->
      <vxe-grid ref="xGrid" v-bind="gridOptions">
        <template #toolbar_buttons="{row}"> </template>
        <template #toolbar_tools="{row}">
          <el-button
            type="primary"
            v-if="dialogObj.mode != 'view'"
            @click="handleChoose"
          >
            关联文档
          </el-button>
          <el-button type="primary" plain @click="doExport">导出</el-button>
        </template>

        <!-- 操作列 -->
        <template #tool="{ row }">
          <el-button
            type="text"
            class="table-operation-icon"
            @click="handleDelete(row)"
          >
            <svg-icon icon-class="yichu" class="red"></svg-icon>
          </el-button>
        </template>

        <!-- 公示日期 -->
        <template #releaseDate_header="{row}">
          <div class="sort_class">
            <span class="padding_right20">公示日期</span>
            <svg-icon
              icon-class="sanjiao_fill"
              class="ml5 sort_icon sort_shengxu"
              :class="{
                sort_bg:
                  searchForm.fieldSort == 1 && searchForm.fieldType == '0'
              }"
              @click="getSort('0', '1')"
            ></svg-icon>
            <svg-icon
              icon-class="sanjiao_fill"
              class="ml5 sort_icon sort_jiangxu"
              :class="{
                sort_bg:
                  searchForm.fieldSort == 0 && searchForm.fieldType == '0'
              }"
              @click="getSort('0', '0')"
            ></svg-icon>
          </div>
        </template>

        <!-- 施行日期 -->
        <template #applyDate_header="{row}">
          <div class="sort_class">
            <span class="padding_right20">施行日期</span>
            <svg-icon
              icon-class="sanjiao_fill"
              class="ml5 sort_icon sort_shengxu"
              :class="{
                sort_bg:
                  searchForm.fieldSort == 1 && searchForm.fieldType == '1'
              }"
              @click="getSort('1', '1')"
            ></svg-icon>
            <svg-icon
              icon-class="sanjiao_fill"
              class="ml5 sort_icon sort_jiangxu"
              :class="{
                sort_bg:
                  searchForm.fieldSort == 0 && searchForm.fieldType == '1'
              }"
              @click="getSort('1', '0')"
            ></svg-icon>
          </div>
        </template>

        <!-- 创建日期 -->
        <template #createDate_header="{row}">
          <div class="sort_class">
            <span class="padding_right20">创建日期</span>
            <svg-icon
              icon-class="sanjiao_fill"
              class="ml5 sort_icon sort_shengxu"
              :class="{
                sort_bg:
                  searchForm.fieldSort == 1 && searchForm.fieldType == '2'
              }"
              @click="getSort('2', '1')"
            ></svg-icon>
            <svg-icon
              icon-class="sanjiao_fill"
              class="ml5 sort_icon sort_jiangxu"
              :class="{
                sort_bg:
                  searchForm.fieldSort == 0 && searchForm.fieldType == '2'
              }"
              @click="getSort('2', '0')"
            ></svg-icon>
          </div>
        </template>
        <!-- <template #edit_integer="{ row }">
          <vxe-input
            v-model="row.sort"
            min="0"
            max="99999999"
            type="integer"
            @blur="changeSort(row)"
            placeholder="请输入"
          ></vxe-input>
        </template> -->
        <template #default_integer="{ row }">
          <div
            v-if="row.sort === 0 || row.sort"
            class="color-primary cursor-pointer"
          >
            {{ row.sort }}
          </div>
          <svg-icon
            v-else
            class="color-primary cursor-pointer"
            icon-class="edit"
          ></svg-icon>
        </template>
      </vxe-grid>

      <div class="table-footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageList"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          v-if="showPage || total > 0"
        >
        </el-pagination>
      </div>

      <!-- 选择关联文库 -->
      <choose-relate-dialog
        ref="chooseRelate"
        v-if="chooseRelate"
        @updateSearch="fetchData"
      ></choose-relate-dialog>
    </template>
  </el-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { exportPlus } from "utils/tools";
import XEUtils from "xe-utils";
import chooseRelateDialog from "./choose-relate-dialog.vue";
import * as typeApi from "api/modules/library/library-type-management/index.js";
export default {
  components: {
    chooseRelateDialog
  },
  data() {
    return {
      dialogObj: {
        visible: false,
        title: "已关联文库",
        width: "1200px",
        mode: "add"
      },
      searchForm: {
        title: "", // 标题
        referNo: "", // 文号
        issueUnit: "", // 颁布机关
        efficient: [], // 时效性
        dateArr: "", //  实行日期
        applyStartDate: "", // 实行日期（起）
        applyEndDate: "", // 实行日期（止）
        type: [], // 所属分类
        fieldType: "", // 排序字段
        fieldSort: "", // 排序类型（0降序，1升序)
        isBind: "1" // 展示已关联的文库
      },

      // 静态列配置
      showMoreSearch: false, // 搜索 展开

      currentPage: 1, // 当前页码
      pageList: [10, 20, 50, 100], // 显示条数数组
      pageSize: 10, // 当前显示条数
      total: 0, // 当前总条数
      showPage: false,
      loading: false,
      // 表格配置
      gridOptions: {
        showOverflow: true, // 开启溢出隐藏
        autoResize: true,
        border: true,
        toolbarConfig: {
          custom: false,
          slots: {
            buttons: "toolbar_buttons", // 左侧
            tools: "toolbar_tools" // 右侧
          }
        }, // 工具栏配置
        tooltipConfig: {
          showAll: true,
          zIndex: 9999
        },
        rowConfig: {
          keyField: "id",
          isHover: true,
          isCurrent: true
        }, // 行配置
        columnConfig: {
          resizable: true
        }, // 列配置
        columns: [],
        height: "400px",
        editConfig: {
          trigger: "click",
          mode: "cell",
          showIcon: false
        }
      },
      typeRow: "", // 文库类型的id
      typeDict: [], // 所属分类数组
      aliasName: "relate",
      chooseRelate: false // 选择关联文库弹窗显隐
    };
  },
  created() {},
  mounted() {},
  methods: {
    /********************   弹框打开与关闭   ********************/
    // 弹框初始化
    initDialog(data, type) {
      //  弹窗打开
      this.dialogObj.visible = true;
      //  弹窗模式
      this.dialogObj.mode = type ? type : "add";
      // 文库赋值
      this.typeRow = data;
      // 将搜索条件收起
      this.showMoreSearch = false;
      // 重置表单
      this.searchForm = {
        title: "", // 标题
        referNo: "", // 文号
        issueUnit: "", // 颁布机关
        efficient: [], // 时效性
        dateArr: "", //  实行日期
        applyStartDate: "", // 实行日期（起）
        applyEndDate: "", // 实行日期（止）
        type: [], // 所属分类
        fieldType: "", // 排序字段
        fieldSort: "", // 排序类型（0降序，1升序)
        isBind: "1" // 展示已关联的文库
      };

      // 所属分类赋值
      this.searchForm.type = this.typeRow.id?.split();

      // 获取静态列配置
      this.getStaticColumns();
    },

    // 关闭弹窗
    closeDialog() {
      //  关闭弹窗
      this.dialogObj.visible = false;

      this.$emit("updateSearch");
      setTimeout(() => {
        this.btnLoading = false;
      }, 1000);
    },

    /********************   表格相关操作   ********************/

    //  静态数组（全列头）
    getStaticColumns() {
      let arr;
      if (this.dialogObj.mode != "view") {
        arr = this.staticColumns.filter(i => !["sort"].includes(i.field));
        this.gridOptions.columns = XEUtils.clone(arr, true);
      } else {
        arr = this.staticColumns.filter(i => !["tool"].includes(i.field));
        if (this.typeRow.children && this.typeRow.children.length > 0) {
          arr = arr.filter(i => !["sort"].includes(i.field));
        }
        this.gridOptions.columns = XEUtils.clone(arr, true);
      }
      this.$nextTick(() => {
        this.$refs.xGrid && this.$refs.xGrid.refreshColumn();
        this.fetchData();
      });
    },

    // 异步抓取数据
    fetchData() {
      let params = { ...JSON.parse(JSON.stringify(this.searchForm)) };
      // 时间段数据处理
      params.applyStartDate =
        params.dateArr && params.dateArr.length > 0 ? params.dateArr[0] : "";
      params.applyEndDate =
        params.dateArr && params.dateArr.length > 0 ? params.dateArr[1] : "";
      // 删除时间段
      delete params.dateArr;
      // 文库类型id
      params.typeId = this.typeRow.id;
      params.current = this.currentPage;
      params.size = this.pageSize;

      this.loading = true;
      this.gridOptions.data = [];
      this.total = 0;
      typeApi
        .selectDocManage(params)
        .then(res => {
          if (res.code == 0) {
            // 所属分类数组赋值
            this.typeDict = res.data.docTypeTree;
            this.gridOptions.data = res.data.docManagePage.records;
            this.total = Number(res.data.docManagePage.total);
            this.showPage = Number(res.data.docManagePage.total) === 0;
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },

    // 导出
    doExport() {
      // 搜索条件
      let search = JSON.parse(JSON.stringify(this.searchForm));
      const params = {
        ...search,
        columns: this.gridOptions.columns.filter(
          i => !!i.visible && !["tool"].includes(i.field)
        )
      };
      params.columns[0].field = "index";
      // 文库类型id
      params.typeId = this.typeRow.id;
      exportPlus("/docType/exportDocManage", params);
    },

    // 切换显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },

    /********************   搜索表单处理   ********************/

    // 处理排序
    getSort(type, status) {
      // 排序赋值
      this.searchForm.fieldType = type;
      this.searchForm.fieldSort = status;

      // 获取列表数据
      this.fetchData();
    },

    // 选择日期change
    onChangeDate(arr) {
      this.searchForm.planStart = arr ? arr[0] : "";
      this.searchForm.planEnd = arr ? arr[1] : "";
    },

    // 删除文库
    handleDelete(row) {
      this.$confirm("删除后不可恢复，是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(status => {
        if (!status) {
          return;
        }
        let params = {
          manageId: row.id,
          typeId: this.typeRow.id
        };
        typeApi.delDocManage(params).then(res => {
          if (res.code == 0) {
            this.$message.success({ message: "删除成功!" });
            if (this.gridOptions.data?.length == 1) {
              this.currentPage = 1;
            } //如果原本列表仅剩一条被删除的数据 返回第一页
            this.fetchData();
          }
        });
      });
    },

    // 重置
    resetSearch() {
      // 重置表单
      this.searchForm = {
        title: "", // 标题
        referNo: "", // 文号
        issueUnit: "", // 颁布机关
        efficient: [], // 时效性
        dateArr: "", //  实行日期
        applyStartDate: "", // 实行日期（起）
        applyEndDate: "", // 实行日期（止）
        type: [], // 所属分类
        fieldType: "", // 排序字段
        fieldSort: "", // 排序类型（0降序，1升序)
        isBind: "1" // 展示已关联的文库
      };

      // 所属分类赋值
      this.searchForm.type = this.typeRow.id?.split();
      this.fetchData();
    },

    // 选择关联文库
    handleChoose() {
      this.chooseRelate = true;
      setTimeout(() => {
        this.$refs.chooseRelate &&
          this.$refs.chooseRelate.initDialog(this.typeRow);
      }, 200);
    }
    // // 排序变更
    // changeSort(row) {
    //   let params = {
    //     typeId: this.typeRow.id,
    //     manageId: row.id,
    //     sort: row.sort == "" ? 0 : row.sort
    //   };
    //   typeApi.setSort(params).then(res => {
    //     if (res.code == 0) {
    //       this.fetchData();
    //     }
    //   });
    // }
  },
  computed: {
    ...mapState("dict", {
      projectDict: state => state.projectDict //项目字典
    }),
    // 静态列
    staticColumns() {
      return [
        {
          type: "seq",
          title: "序号",
          width: 70,
          align: "left",
          headerAlign: "left",
          visible: true,
          forbidCheck: 1,
          forbidDrag: 1
        },
        {
          title: "操作",
          field: "tool",
          width: 60,
          visible: true,
          slots: { default: "tool" }
        },
        // {
        //   title: "排序",
        //   field: "sort",
        //   width: 90,
        //   visible: true,
        //   editRender: {},
        //   slots: { edit: "edit_integer", default: "default_integer" }
        // },
        {
          field: "title",
          title: "标题",
          minWidth: 220,
          align: "left",
          headerAlign: "left",
          visible: true,
          forbidCheck: 1,
          forbidDrag: 1
        },
        {
          field: "issueUnit",
          title: "颁布机关",
          minWidth: 100,
          visible: true
        },
        {
          field: "referNo",
          title: "文号",
          minWidth: 100,
          visible: true
        },
        {
          field: "efficientName",
          title: "时效性",
          width: 100,
          visible: true
        },
        {
          field: "releaseDate",
          title: "公示日期",
          minWidth: 100,
          visible: true,
          slots: { header: "releaseDate_header" }
        },
        {
          field: "applyDate",
          title: "施行日期",
          minWidth: 100,
          visible: true,
          slots: { header: "applyDate_header" }
        },
        {
          field: "createUser",
          title: "创建人",
          width: 100,
          visible: true
        },
        {
          field: "createDate",
          title: "创建日期",
          minWidth: 100,
          visible: true,
          slots: { header: "createDate_header" }
        }
      ];
    }
  },
  watch: {}
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog {
  max-height: 700px !important;
  overflow-x: auto;
}
/deep/ .vxe-table--tooltip-wrapper .theme--dark .is--enterable .is--arrow {
  z-index: 999999;
}
.w100 {
  width: 100% !important;
}
.sp-cascader {
  /deep/.el-input__inner {
    height: 36px !important;
  }
}
.sort_class {
  position: relative;
  .padding_right20 {
    padding-right: 20px;
  }
  .sort_icon {
    position: absolute;
    top: 0;
    right: 5px;
    width: 0.7em !important;
    height: 0.9em !important;
    color: #c0c4cc;
    cursor: pointer;
  }
  .sort_jiangxu {
    top: 12px !important;
    transform: rotate(180deg);
  }
  .sort_bg {
    color: #3ba1ff;
  }
}
.red {
  color: red;
}
/deep/.table-form .el-select .el-tag {
  max-width: 70px;
}
/deep/ .vxe-table--render-default.vxe-editable .vxe-body--column {
  height: 40px;
}
.cursor-pointer {
  cursor: pointer;
}
.table-footer {
  display: flex;
  align-items: center;
  justify-self: center;
  margin-top: 10px;
}
</style>
